var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { gql } from '@apollo/client/core';
import * as Attachment from './Attachment';
const CREATE_ATTACHMENT_MUTATION = gql `
  mutation SaveAttachmentMeta($attachment: CreateAttachmentInput!) {
    createAttachment(input: $attachment) {
      attachment {
        id
        accountId
        checksum
        derivedFromId
        mime
        name
        size
        status
      }
      clientMutationId
      errors
    }
  }
`;
export const savePendingAttachmentMeta = (client, attachment) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield client.mutate({
        mutation: CREATE_ATTACHMENT_MUTATION,
        variables: {
            attachment: {
                attachment,
            },
        },
    });
    if (data.createAttachment.attachment) {
        return Attachment.fromGql(data.createAttachment.attachment);
    }
});
//# sourceMappingURL=Api.js.map